module.exports = __webpack_public_path__ + "z/proximanova-bold-webfont.c9f3301f.svg";